import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.JobOfferArticleView.heading',
    defaultMessage: 'Oferty pracy'
  },
  returnToJobOffersList: {
    id: 'views.JobOfferArticleView.returnToJobOffersList',
    defaultMessage: 'POWRÓT DO LISTY OFERT PRACY'
  },
  others: {
    id: 'views.JobOfferArticleView.others',
    defaultMessage: 'POZOSTAŁE'
  },
  buttonQuestion: {
    id: 'views.JobOfferArticleView.button.question',
    defaultMessage: 'NIE ZNALAZŁEŚ ODPOWIEDNIEGO STANOWISKA?'
  },
  buttonSendCV: {
    id: 'views.JobOfferArticleView.button.sendCV',
    defaultMessage: 'WYŚLIJ CV MIMO TO!'
  },
  joinOurTeam: {
    id: 'views.JobOfferArticleView.joinOurTeam',
    defaultMessage:
      'JESTEŚ ZAINTERESOWANY OFERTĄ? \nNIE WAHAJ SIĘ I DOŁĄCZ DO NASZEGO FANTASTYCZNEGO ZESPOŁU!'
  },
  apply: {
    id: 'views.JobOfferArticleView.apply',
    defaultMessage: 'APLIKUJ'
  }
});



// WEBPACK FOOTER //
// ./src/views/JobOfferArticle/JobOfferArticleView.intl.js